/**
 * DevExtreme (esm/__internal/core/m_renderer.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import rendererBase from "../../core/renderer_base";
const renderer = rendererBase.get();
export { renderer };
export default renderer;